import { toast } from "react-toastify";

const CopyToClipBoard = (id, text = "Ítem copiado al portapapeles") => {
  try {
    navigator.clipboard.writeText(id)
    toast.success(text)
  } catch (e) {
    toast.error("Error al copiar el ítem: " + e);
  }
}

export default CopyToClipBoard